import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const customAccordionStyles = {
  accordion: {
    background: "transparent",
    boxShadow: "none",
  },
  summary: (theme: Theme): SystemStyleObject<Theme> => ({
    color: theme.palette.text.primary,
  }),
};

export default customAccordionStyles;
